import { configureStore } from "@reduxjs/toolkit";
import cartReducer from "./features/cartSlice";
import currencyReducer from "./features/currencySlice";
export const store = configureStore({
  reducer: {
    cartState: cartReducer,
    currencyState: currencyReducer,
  },
  devTools: true,
});
export function mapStateToProps(state) {
  return { cartState: state.cartState, currencyState: state.currencyState };
}
store.subscribe(() => {
  localStorage.setItem("products", JSON.stringify(store.getState().cartState));
  localStorage.setItem(
    "currency",
    JSON.stringify(store.getState().currencyState)
  );
});
